import Vue from 'vue'

const SET_CLIENTE_LOGADO = (state,cliente) => {
	state.logado = cliente
}

export{
	SET_CLIENTE_LOGADO
}
